const steps = [
  {
    number: '01',
    title: 'Análisis de marca',
    description: 'Estudiamos tu marca, audiencia, competencia y objetivos para crear una base sólida.',
    icon: 'ri-search-line'
  },
  {
    number: '02',
    title: 'Estrategia',
    description: 'Diseñamos un plan personalizado con objetivos claros y acciones específicas.',
    icon: 'ri-lightbulb-line'
  },
  {
    number: '03',
    title: 'Creación de contenido',
    description: 'Producimos contenido creativo, auténtico y alineado con tu identidad de marca.',
    icon: 'ri-brush-line'
  },
  {
    number: '04',
    title: 'Publicación y gestión',
    description: 'Publicamos en los mejores horarios y gestionamos la interacción con tu comunidad.',
    icon: 'ri-calendar-check-line'
  },
  {
    number: '05',
    title: 'Análisis y optimización',
    description: 'Medimos resultados y optimizamos constantemente para maximizar el impacto.',
    icon: 'ri-bar-chart-line'
  }
];

export default function Process() {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Elementos decorativos */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-pink-200/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-80 h-80 bg-purple-200/30 rounded-full blur-3xl"></div>

      <div className="relative max-w-5xl mx-auto px-6">
        {/* Título */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-purple-900 mb-4">
            Mi proceso para hacer crecer tu marca
          </h2>
          <p className="text-gray-600 text-lg">
            Un método probado que genera resultados consistentes
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Línea vertical central */}
          <div className="absolute left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-pink-500 via-purple-500 to-pink-500 transform -translate-x-1/2 hidden md:block"></div>

          {/* Steps */}
          <div className="space-y-16">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`relative flex items-center ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Contenido */}
                <div className={`w-full md:w-5/12 ${index % 2 === 0 ? 'md:text-right md:pr-12' : 'md:text-left md:pl-12'}`}>
                  <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all">
                    <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-pink-500 to-purple-600 text-white font-bold text-2xl rounded-2xl mb-4 ${index % 2 === 0 ? 'md:float-right md:ml-4' : 'md:float-left md:mr-4'}`}>
                      {step.number}
                    </div>
                    <h3 className="text-2xl font-bold text-purple-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Icono central */}
                <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2 w-16 h-16 items-center justify-center bg-white rounded-full border-4 border-pink-500 shadow-lg z-10">
                  <i className={`${step.icon} text-2xl text-purple-600`}></i>
                </div>

                {/* Espacio vacío del otro lado */}
                <div className="hidden md:block w-5/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
